import GazableButton from "components/GazableButton/GazableButton";
import gazableButtons from "constants/gazableButtons";
import { setCanvasSize } from "helpers/mathFunctions";
import { styles } from "./styles";
import { useCanvasStore } from "store/CanvasStore";

const GameControls = () => {
  const {
    canvasObj,
    showBuild,
    isBuilding,
    resumePauseGame,
    showHideTowerBuild,
    stopTowerBuild,
  } = useCanvasStore();
  const { height, scale } = setCanvasSize();

  if (canvasObj == null) {
    return <></>;
  }

  return (
    <div
      style={{
        ...styles.gazableGameControls,
        height,
        width: scale * 350,
      }}
    >
      <GazableButton
        type={gazableButtons.squareButton}
        content={showBuild || isBuilding ? "Cancel Build" : "Build Towers"}
        onClick={() => {
          if (!canvasObj.paused) {
            resumePauseGame();
          }
          if (!isBuilding) {
            showHideTowerBuild();
          } else {
            stopTowerBuild();
          }
        }}
      />
      <GazableButton
        type={gazableButtons.squareButton}
        content={canvasObj.paused ? "Resume" : "Pause"}
        onClick={() => {
          resumePauseGame();
          stopTowerBuild();
          if (showBuild) {
            showHideTowerBuild();
          }
        }}
      />
      <GazableButton
        type={gazableButtons.squareButton}
        content="Restart Level"
        onClick={() => {
          if (!canvasObj.paused) {
            resumePauseGame();
          }
          stopTowerBuild();
          if (showBuild) {
            showHideTowerBuild();
          }
          canvasObj.restartGame();
        }}
      />
    </div>
  );
};

export default GameControls;
